module.exports = __webpack_public_path__ + "static/media/down-arrow.4959ee5f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/regscoaches/down-arrow.svg
// module id = 798
// module chunks = 0